import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { H1 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph2, Paragraph3 } from '@r1-frontend/ui-react/components/typography/paragraph';
import TextWrapper from '@r1-frontend/ui-react/components/typography/TextWrapper';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { NBSP } from '@r1-frontend/ui-react/tokens/symbols';
import { useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';

import { useValueByBreakpoint } from '~/src/helpers/hooks/useValueByBreakpoint';

import * as ST from './styled';

const imgPath = '/static/images/about/v2/header-bg-';
const paragraphText = `Ваш надёжный помощник в${NBSP}мире цифровых технологий с${NBSP}2001 года`;

const Header = () => {
    const isMobile = useMatchMediaByWidth(wideBreakpoints.mobile);

    const backgroundWebpUrl = useValueByBreakpoint({
        desktop: imgPath + 'desktop.webp',
        laptop: imgPath + 'laptop.webp',
        mobile: imgPath + 'mobile.webp',
    });

    const backgroundUrl = useValueByBreakpoint({
        desktop: imgPath + 'desktop.png',
        laptop: imgPath + 'laptop.png',
        mobile: imgPath + 'mobile.png',
    });

    return (
        <ST.Header backgroundImage={backgroundUrl} backgroundImageWebp={backgroundWebpUrl}>
            <ST.Container>
                <ST.AgeRating>18+</ST.AgeRating>
                <TextWrapper $lastIndent={false}>
                    <H1>Дом.ру</H1>
                    {isMobile
                        ? <Paragraph3 data-test='paragraph3' $color={COLORS.TextSecondary}>{paragraphText}</Paragraph3>
                        : <Paragraph2 data-test='paragraph2' $smaller $color={COLORS.TextSecondary}>{paragraphText}</Paragraph2>}
                </TextWrapper>
            </ST.Container>
        </ST.Header>
    );
};

export default Header;
